var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93.641,
    height: 71.694,
    viewBox: "0 0 93.641 71.694",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10159",
    "data-name": "Grupo 10159",
    transform: "translate(-725.314 -3362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7076",
    "data-name": "Trazado 7076",
    d: "M159.878,132.77H118.84a1.8,1.8,0,0,1-1.8-1.8V103.452a1.8,1.8,0,0,1,1.8-1.8h41.038a1.8,1.8,0,0,1,1.8,1.8v27.516a1.8,1.8,0,0,1-1.8,1.8Zm-39.237-3.6h37.437V105.253H120.641Z",
    transform: "translate(608.274 3260.348)",
    fill: "#b1ca56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7077",
    "data-name": "Trazado 7077",
    d: "M196.559,250.554H180.177a1.8,1.8,0,0,1-1-3.294c4.376-2.944,3.076-6.161,3.063-6.19a1.8,1.8,0,1,1,3.315-1.407,7.428,7.428,0,0,1,.39,3.714h0a8.536,8.536,0,0,1-1.377,3.578h7.609a8.537,8.537,0,0,1-1.378-3.578,7.48,7.48,0,0,1,.392-3.714l3.315,1.407.01-.026c-.13.338-1.157,3.387,3.051,6.219a1.8,1.8,0,0,1-1,3.294Z",
    transform: "translate(559.264 3150.953)",
    fill: "#b1ca56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7078",
    "data-name": "Trazado 7078",
    d: "M403.688,292.9H362.65a1.8,1.8,0,0,1-1.8-1.8V263.579a1.8,1.8,0,0,1,1.8-1.8h41.038a1.8,1.8,0,0,1,1.8,1.8V291.1a1.8,1.8,0,0,1-1.8,1.8Zm-39.237-3.6h37.437V265.38H364.451Z",
    transform: "translate(413.466 3132.404)",
    fill: "#b1ca56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7079",
    "data-name": "Trazado 7079",
    d: "M440.381,415.059H424a1.8,1.8,0,0,1-1-3.294c4.207-2.832,3.18-5.876,3.05-6.214l.01.025,3.315-1.406a7.439,7.439,0,0,1,.392,3.714,8.541,8.541,0,0,1-1.378,3.578h7.609a8.544,8.544,0,0,1-1.377-3.578,7.5,7.5,0,0,1,.39-3.714l3.315,1.406.01-.025c-.13.338-1.157,3.387,3.052,6.219h0a1.8,1.8,0,0,1-1,3.294Z",
    transform: "translate(364.445 3018.63)",
    fill: "#b1ca56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7080",
    "data-name": "Trazado 7080",
    d: "M477.288,199.535a1.8,1.8,0,0,1-1.8-1.8v-7.158H464.356a1.8,1.8,0,0,1,0-3.6h12.932a1.8,1.8,0,0,1,1.8,1.8v8.959a1.8,1.8,0,0,1-1.8,1.8Z",
    transform: "translate(332.2 3192.174)",
    fill: "#b1ca56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7081",
    "data-name": "Trazado 7081",
    d: "M413.423,168.586a1.8,1.8,0,0,1-.9-.242l-12.631-7.292a1.8,1.8,0,0,1,0-3.119l12.631-7.293a1.8,1.8,0,0,1,2.7,1.56v14.585a1.8,1.8,0,0,1-1.8,1.8Zm-9.03-9.094,7.229,4.174V155.32Z",
    transform: "translate(382.99 3221.397)",
    fill: "#b1ca56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7082",
    "data-name": "Trazado 7082",
    d: "M169.908,323.095H156.976a1.8,1.8,0,0,1-1.8-1.8v-8.959a1.8,1.8,0,1,1,3.6,0v7.158h11.131a1.8,1.8,0,1,1,0,3.6Z",
    transform: "translate(577.803 3093.447)",
    fill: "#b1ca56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7083",
    "data-name": "Trazado 7083",
    d: "M222.04,337.29a1.8,1.8,0,0,1-1.8-1.8V320.9a1.8,1.8,0,0,1,2.7-1.559l12.631,7.292a1.8,1.8,0,0,1,0,3.119l-12.631,7.293A1.813,1.813,0,0,1,222.04,337.29Zm1.8-13.266v8.347l7.229-4.174Z",
    transform: "translate(525.816 3086.6)",
    fill: "#b1ca56"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemote);
export default __webpack_public_path__ + "static/media/remote.f96038f0da7076f7331d360c1606fbff.svg";
export { ForwardRef as ReactComponent };